import { getInstance, init, registerRemotes } from '@module-federation/enhanced/runtime';

export const STUDIO_REMOTE = 'http://127.0.0.1:5740/mf-manifest.json';

const remotes = [{ name: 'goshStudio', entry: STUDIO_REMOTE }];

let started = false;

/** 宿主只 init 一次。热更新后实例还在时，把远程补登记进去。 */
export function ensureMfRuntime() {
  if (started) return;
  if (!getInstance()) {
    init({
      name: 'ghostoreAdmin',
      remotes,
    });
  } else {
    registerRemotes(remotes);
  }
  started = true;
}
